import {
  Button,
  NativeSelect,
  TextField,
  LinearProgress,
  OutlinedInput,
  Grid,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Card from "react-credit-cards";
import useMercadoPago from "./hooks/useMercadoPago";
import { MPLogo } from "../assets/images";

import "react-credit-cards/es/styles-compiled.css";
import "./MercadoPagoForm.styles.css";
import { useRedirect, useNotify } from "react-admin";
import { getNextDateFromDay } from "../utils/DateTimeUtils";

const INITIAL_STATE = {
  cvc: "",
  cardExpirationMonth: "",
  cardExpirationYear: "",
  focus: "cardNumber",
  cardholderName: "",
  cardNumber: "",
  issuer: "",
};

export default function MercadoPagoForm({ plans }) {
  const [state, setState] = useState(INITIAL_STATE);
  const { resultPayment, isLoading } = useMercadoPago();
  const redirect = useRedirect();
  const notify = useNotify();

  const restaurant = JSON.parse(localStorage.getItem("restaurant"));
  const restaurantPlan = plans.filter(
    (p) => p._id === restaurant?.subscriptionPlan
  )[0];

  const handleInputChange = (e) => {
    setState({
      ...state,
      [e.target.dataset.name || e.target.name]: e.target.value,
    });
  };

  const handleInputFocus = (e) => {
    setState({ ...state, focus: e.target.dataset.name || e.target.name });
  };

  useEffect(() => {
    if (resultPayment) {
      if (resultPayment.error) {
        notify(`Ha ocurrido un error: ${resultPayment.message}`, {
          type: "error",
        });
      } else {
        // Save updated restaurant and redirect to Payments
        notify("¡La suscripción se ha realizado exitosamente!", {
          type: "success",
        });
        localStorage.setItem("restaurant", JSON.stringify(resultPayment));
        redirect("/payments");
      }
    }
  }, [notify, redirect, resultPayment]);

  return (
    <Grid container spacing={2} sx={{ alignItems: "center" }}>
      <Grid size={12}>
        <p>
          Te estás suscribiendo al plan <b>{restaurantPlan?.name}</b>.
        </p>
        <p>
          Pagarás con tu tarjeta de crédito <b>${restaurantPlan?.price}</b> cada
          mes, a partir del <b>{getNextDateFromDay(15)}</b>.
        </p>
      </Grid>
      <Grid size={{ xs: 12, md: "auto" }}>
        <form id="form-checkout">
          <div className="form-control">
            <div>
              <TextField
                type="tel"
                name="cardNumber"
                id="form-checkout__cardNumber"
                onChange={handleInputChange}
                onFocus={handleInputFocus}
                required
                variant="outlined"
                margin="dense"
              />
            </div>
          </div>
          <div className="form-control">
            <Grid container spacing={2}>
              <Grid size="auto">
                <TextField
                  type="tel"
                  name="cardExpirationMonth"
                  id="form-checkout__cardExpirationMonth"
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  className="input-month"
                  inputProps={{
                    maxLength: 2,
                    inputMode: "numeric",
                    pattern: "(0[1-9]|1[012])",
                  }}
                  // helperText="MM"
                  required
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid size="auto">
                <TextField
                  type="tel"
                  name="cardExpirationYear"
                  id="form-checkout__cardExpirationYear"
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  inputProps={{
                    maxLength: 4,
                    inputMode: "numeric",
                    pattern: "(?:[0-9]{2})?[0-9]{2}",
                  }}
                  // helperText="YY"
                  required
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid size="auto">
                <TextField
                  type="tel"
                  name="cvc"
                  id="form-checkout__securityCode"
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  className="input-cvc"
                  inputProps={{
                    maxLength: 4,
                  }}
                  required
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
            </Grid>
          </div>
          <div className="form-control">
            <Grid container spacing={2}>
              <Grid size="auto">
                <TextField
                  type="text"
                  name="cardholderName"
                  id="form-checkout__cardholderName"
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  className="input-name"
                  inputProps={{
                    maxLength: 30,
                  }}
                  required
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid size="auto">
                <TextField
                  type="email"
                  name="cardholderEmail"
                  id="form-checkout__cardholderEmail"
                  onFocus={handleInputFocus}
                  required
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
            </Grid>
          </div>
          <div className="form-control">
            <Grid container spacing={2}>
              <Grid size="auto">
                <select
                  name="issuer"
                  id="form-checkout__issuer"
                  on="true"
                  className="input-hidden"
                ></select>
                <NativeSelect
                  name="identificationType"
                  id="form-checkout__identificationType"
                  className="input-idType MuiFormControl-marginDense"
                  variant="outlined"
                  margin="dense"
                  input={<OutlinedInput />}
                ></NativeSelect>
              </Grid>
              <Grid size="auto">
                <TextField
                  type="text"
                  name="identificationNumber"
                  id="form-checkout__identificationNumber"
                  inputProps={{
                    maxLength: 16,
                  }}
                  required
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
            </Grid>
          </div>
          <div className="form-control">
            <Grid container>
              <Grid size={{ xs: 12, md: "auto" }}>
                <select
                  name="installments"
                  id="form-checkout__installments"
                  className="input-hidden"
                ></select>
              </Grid>
            </Grid>
          </div>
          <div className="form-control">
            <Grid container>
              <Grid size={{ xs: 12, md: "auto" }}>
                <Button
                  type="submit"
                  id="form-checkout__submit"
                  variant="contained"
                  // color="success"
                  className="buttom-submit"
                  disabled={isLoading}
                  size="large"
                >
                  Suscribirse
                </Button>
              </Grid>
            </Grid>
            {isLoading && <LinearProgress style={{ marginTop: "25px" }} />}
          </div>
        </form>
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <div className="card-container">
          <div className="card-inner-container">
            <Card
              cvc={state.cvc}
              expiry={state.cardExpirationMonth + state.cardExpirationYear}
              name={state.cardholderName}
              number={state.cardNumber}
              focused={state.focus}
              brand={state.issuer}
              locale={{ valid: "vence" }}
              placeholders={{ name: "NOMBRE Y APELLIDO" }}
            />
          </div>
          <img src={MPLogo} width="120" alt="MercadoPago" />
        </div>
      </Grid>
    </Grid>
  );
}
